import React from "react";
import Navigation from "./Nav";

const Header = () => {
  return (
    <div>
      <Navigation />
    </div>
  );
};

export default Header;
